import type { FC } from 'react';
import type { TIconName } from './registry';

import type { TIconProps } from './icon.props';

import { ICONS } from './registry';

type TIconComponentProps = TIconProps & {
  name: TIconName;
};

const Icon: FC<TIconComponentProps> = ({ name, ...rest }) => {
  const Glyph = ICONS[name];

  return <Glyph {...rest} />;
};

export type {
  TIconComponentProps,
};
export {
  Icon,
};
